export default __webpack_public_path__ + "static/media/PM.8a174008.svg";